import { toDemotion } from '@utils/index'
import { split, toNumber, divide, isInteger,isNaN,toString, toInteger, isString, isNumber } from 'lodash';

export function install(Vue: Vue.VueConstructor) {
  Vue.filter('price', (value: any) => {
    return toDemotion(value)
  })
  Vue.filter('distance', (value: any) => {
    return toDemotion(value, 1000)
  })
  Vue.filter('priceRange', (item: any) => {
    return item && item.minPrice != item.maxPrice ? '起' : null;
  })
  Vue.filter('imgOne', (imgUrls: any) => {
    return imgUrls && split(imgUrls,',')[0]
  })
  Vue.filter('integer', (num: string | number) => {
    const n = toInteger(num)
    const YW = 10000
    let str = ''
    if(n >= YW) {
      const sz = divide(n,YW)
      const ir = toInteger(sz);
      str  =  `${ir}w${isInteger(sz) ? '' : '+'}`
    }
    
    return str || n
  })
  Vue.filter('saleNum', (saleNum: number) => {
    if (saleNum >= 10000) {
      return toDemotion(saleNum, 10000) + '万'
    }
    if (isNumber(saleNum)) {
      return saleNum
    }
    return 0
  })
  Vue.filter('promotionText', (tag: any) => {
    if (isString(tag)) {
      if (tag.length > 7) {
         return tag.substring(0, 7) + '..'
       }
     }
    return tag
  })
  Vue.filter('babyImg', (tag: any) => {
    const { bid, nickname, photo, sex, age  } = tag || {}
    if (tag) {
      //bid不为空 说明是已经登陆的宝宝
      if (bid) {
        //nickname不为空 说明已经出生的
        if (nickname) {
          if (photo) {
            return photo
          } else if (+sex === 1) {
            return require('@assets/images/home/icon_baby_girl.png')
          } else {
            return require('@assets/images/home/icon_baby_boy.png')
          }
        } else {
          return require('@assets/images/home/icon_pregrant.png')
        }
      } else {
        //表示未登录 本地选择的 分怀孕中，和具体出生的  age自己定义的参数 不是接口返回
        return  age === '怀孕中' ? require('@assets/images/home/icon_pregrant.png') : require('@assets/images/home/icon_baby_nologin.png')
      }
    } else {
      return require('@assets/images/home/icon_baby_nologin.png')
    }
  })
  Vue.filter('babyAge', (tag: any) => {
    const { bid, nickname,  age  , birthdiscribe } = tag || {}
    if (tag) {
      //bid不为空 说明是已经登陆的宝宝
      if (bid) {
        //nickname不为空 说明已经出生的
        if (nickname) {
            return birthdiscribe
        } else {
          return '怀孕中'
        }
      } else {
        //表示未登录 本地选择的 分怀孕中，和具体出生的  age自己定义的参数 不是接口返回
        return age
      }
    } else {
      return '宝宝年龄'
    }
  })
  Vue.filter('maskUid', (uid: any) => {
    if (uid) {
      return uid.toString().replace(/^(\d{3})(\d{4})(\d*)$/, '$1****$3')
    } else {
      return ""
    }
  })
}
